<h2 mat-dialog-title class="dialog-title">
  <mat-icon>domain</mat-icon>
  {{ 'building.egid.management' | transloco }}
</h2>

<mat-dialog-content class="dialog-content">
  <!-- Liste EGID -->
  <mat-chip-listbox class="egid-list">
    @for (egid of egids; track egid; let i = $index) {
    <mat-chip [removable]="true" (removed)="remove(i)" color="primary" selected>
      {{ egid }}
      <button matChipRemove>
        <mat-icon>close</mat-icon>
      </button>
    </mat-chip>
    }
  </mat-chip-listbox>

  <!-- Message limite -->
  @if (egids.length >= max) {
  <div class="limit-warning">
    <mat-icon color="warn">warning</mat-icon>
    {{ 'building.egid.max' | transloco : { max } }}
  </div>
  }

  <!-- Ajout -->
  @if (egids.length < max) {
  <div class="add-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'building.egid.new' | transloco }}</mat-label>
      <input matInput type="number" [(ngModel)]="newEgid" (keyup.enter)="add()" />
      <button mat-icon-button matSuffix color="primary" (click)="add()" [disabled]="!newEgid">
        <mat-icon>add</mat-icon>
      </button>
    </mat-form-field>
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="save()">
    <mat-icon>check</mat-icon>
    {{ 'building.egid.validate' | transloco }}
  </button>

  <button mat-stroked-button (click)="cancel()">
    {{ 'building.egid.cancel' | transloco }}
  </button>
</mat-dialog-actions>
